export enum WindowState {
    WindowStateNormal = 0,
    WindowStateMaximize = 1,
    WindowStateMinimize = 2,
}
